var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGo = function SvgGo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15ZM8.70711 2.79289C8.31658 2.40237 7.68342 2.40237 7.29289 2.79289C6.90237 3.18342 6.90237 3.81658 7.29289 4.20711L9.58579 6.5H3C2.44772 6.5 2 6.94772 2 7.5C2 8.05228 2.44772 8.5 3 8.5H9.58579L7.29289 10.7929C6.90237 11.1834 6.90237 11.8166 7.29289 12.2071C7.68342 12.5976 8.31658 12.5976 8.70711 12.2071L12.7071 8.20711C13.0976 7.81658 13.0976 7.18342 12.7071 6.79289L8.70711 2.79289Z",
    fill: "#2D2C2E"
  })));
};
export default SvgGo;